import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 12 12"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 1a5 5 0 0 0-5 5v4.5a.5.5 0 0 0 .5.5H6A5 5 0 0 0 6 1m1.938 8.5H2l2-2 1 1L6.5 7l2.067 2.067a4 4 0 0 1-.629.433M7 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
      clipRule: "evenodd"
    }
  )
);
var SvgMmsMessageLineLeftFill = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MmsMessageLineLeftFill_default = SvgMmsMessageLineLeftFill;

export { MmsMessageLineLeftFill_default as default };
